export default class FormSubmitAjaxPlugin {
    constructor(form) {
        this.form = form || null;

        this.form.addEventListener('click', this.handlerClickByForm.bind(this));
    }

    async sendForm() {
        const formData = new FormData();

        this.form.querySelectorAll('input,textarea,select').forEach((control) => {

            if(control instanceof HTMLInputElement){
                if(control.getAttribute('type') === 'file'){
                    if(control.files.length){
                        formData.append(control.getAttribute('name'), control.files[0])
                    }
                }else {
                    formData.append(control.getAttribute('name'), control.value);
                }
            }

            if(control instanceof HTMLTextAreaElement){
                formData.append(control.getAttribute('name'), control.value);
            }
        })

        const response = await fetch(this.form.action, {
            method: 'POST',
            headers: {
                'x-october-request-handler': this.form.dataset.formRequest,
                'x-requested-with': 'XMLHttpRequest'
            },
            body: formData
        });

        return await response.json();

    }

    parserResult(response){

        if(response.status === 'errors'){
            [...response.errors].forEach((error) => {

                const control = this.form.querySelector('[name=' + error.code +']');
                control.classList.add('-error');

            });

            const controlError = this.form.querySelector('.-error');

            if(controlError){
                controlError.focus();
            }
        }
        if(response.status === 'success'){

           const top = this.form.getBoundingClientRect().top - (window.innerHeight>>1);
           window.scrollBy({top:  top, left: 0, behavior: 'smooth'});

           this.form.parentNode.innerHTML = response.messageResult;

        }

    }

    handlerClickByForm(event){
        const target = event.target;


        if(target instanceof HTMLButtonElement && target.getAttribute('type') === 'submit'){
            if (!this.form.checkValidity()) {
                return this.form.reportValidity();
            }

            this.form.classList.add('-isLoading');
            this.form.querySelectorAll('button').forEach((control) => {

                control.setAttribute('disabled','disabled')
            });

            this.sendForm().then(this.parserResult.bind(this)).finally(() => {
                this.form.classList.remove('-isLoading');
                this.form.querySelectorAll('button').forEach((control) => {
                    control.removeAttribute('disabled');
                })
            });

            event.preventDefault();

        }

        if (target instanceof HTMLElement) {

                if(target.classList.contains('-error')) {
                    target.classList.remove('-error');
                }
        }
    }

    static init(){
        document.querySelectorAll('form[data-form-request]').forEach((form) => {
                new this(form)
        });
    }
}
